@let IsCircular = type() === 'circular';
<svg [attr.width]="IsCircular ? 15 : 50" [attr.height]="IsCircular ? 15 : 8" [attr.viewBox]="IsCircular ? '0 0 110 110' : '0 0 55 8'"
     class="progress"
     [ngClass]="{'full': _progress() == 100}">
  @if (IsCircular) {
    <circle class="bg"></circle>
    <circle class="fg" pathLength="100" [style.--progress]="_progress()"></circle>
  } @else {
    <line x1="5" y1="4" x2="50" y2="4" class="bg"></line>
    <line x1="5" y1="4" x2="50" y2="4" class="fg" pathLength="100" [style.--progress]="_progress()"></line>
  }
</svg>
